import {
  TableHead,
  TableRow,
  FormControl,
  TableCell,
  NativeSelect,
} from "@mui/material";
import { useEffect } from "react";

import LookupTableConstants from "@/components/membership/ChooseFormulaModal/lookupForm/LookupUtils/LookupTableConstants";
import LookupTableUtils from "@/components/membership/ChooseFormulaModal/lookupForm/LookupUtils/LookupTableUtils";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";
import "@/components/membership/ChooseFormulaModal/lookupForm/LookupTable/LookupTableHeader.css";

const LookupTableHeader = ({
  tableValues,
  lookupColumns,
  updateLookupColumns,
  updateErrors,
}) => {
  const DEFAULT_VALUE = "Select Column Name";
  const { affiliateFileData } = useUpdateDataContext();
  const { columns } = affiliateFileData;
  const { blankLookupColumnValue } = LookupTableConstants;
  const { getEmptyLookupColumnsArray } = LookupTableUtils();

  const onChangeHandler = (e, index) => {
    const temp = [...lookupColumns];
    temp[index] = e.target.value;
    updateLookupColumns(temp);
  };

  useEffect(() => {
    // check for already existing lookup column values
    if (!lookupColumns) {
      updateLookupColumns(getEmptyLookupColumnsArray());
    } else if (
      tableValues &&
      lookupColumns.length < tableValues[0].length - 1
    ) {
      // in the event that the user uploaded a csv with no headers, the following is needed:
      const temp = [...lookupColumns];
      const loopQ = tableValues[0].length - 1 - lookupColumns.length;
      for (let i = 0; i < loopQ; i++) {
        temp.push(blankLookupColumnValue);
      }
      updateLookupColumns(temp);
    }

    // VALIDATE (lookup columns must be selected)
    if (lookupColumns) {
      updateErrors(
        "blankColumns",
        lookupColumns.indexOf(blankLookupColumnValue) !== -1 ||
          lookupColumns.length === 0
      );
    }
    // updateLookupColumns and updateErrors are props/callbacks that change
    // each render; including them would cause infinite re-runs.
    // blankLookupColumnValue is a constant string. getEmptyLookupColumnsArray
    // is recreated by LookupTableUtils() each render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookupColumns, tableValues]);

  return (
    <TableHead id="lookup-formula-table-header">
      <TableRow>
        {lookupColumns &&
          lookupColumns.map((affiliateColumn, index) => {
            return (
              <TableCell
                key={`lookup-table-header-${index}-${affiliateColumn}`}
                row={index}
              >
                <FormControl>
                  <NativeSelect
                    id={`lookup-table-header-dropdown-${affiliateColumn}`}
                    data-testid="select-column-name"
                    defaultValue={
                      affiliateColumn ? affiliateColumn.trim() : DEFAULT_VALUE
                    }
                    onChange={(e) => onChangeHandler(e, index)}
                    key={`lookup-header-select-element-${index}`}
                  >
                    <option value={blankLookupColumnValue}>
                      Select Column Name
                    </option>
                    {columns.map((column_name, columnIndex) => (
                      <option
                        key={`lookup-header-column-key-${columnIndex}`}
                        value={column_name}
                      >
                        {column_name}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
              </TableCell>
            );
          })}
        <TableCell>OUTPUT</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default LookupTableHeader;
